import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";

import EmptyState from '../../../../../../Common/EmptyState';
import { openPullout } from '../../../../../../../Actions/stakeholderActions';
import { Trans } from 'react-i18next';
import { BookingRow } from '../../../../../../Common/DesignSystem/TableRows/VehicleBookingsRow';
import { TabItem, Tabs } from '../../../../../../Common/DesignSystem/Tabs';

const VehicleBookingsTab = (props) => {
    const [currentTab, setCurrentTab] = useState("all");
    const [loading, setLoading] = useState(true);
    const [tabs, setTabs] = useState({});

    useEffect(() => {
        const { bookings, vehicle_details: { bookings: legacyApiBookings } } = props;

        const flattedLegacyApiBookings = Object.keys(legacyApiBookings).map(key => legacyApiBookings[key]).flat();

        const mergedBookings = bookings.map(booking => {
            const legacyApiBooking = flattedLegacyApiBookings.find(legacyApiBooking => legacyApiBooking.BOOK_ID === booking.sourceBookingId);
            return { ...booking, legacyApiBooking };
        });

        const sortedBookings = mergedBookings.sort((first, second) => {
            const firstDate = new Date(first.scheduledReleasedAt);
            const secondDate = new Date(second.scheduledReleasedAt);
            return secondDate - firstDate;
        });

        const bookingsGroupedByStatus = sortedBookings.reduce((acc, currentBooking) => {
            acc[currentBooking.status] = {
                bookingsList: [...acc[currentBooking.status]?.bookingsList || [], currentBooking],
                emptyState: {
                    text: `No ${currentBooking.status} bookings`,
                    image: 'bookings-emptystate.svg'
                }
            };
            return acc;
        }, {});

        setTabs({
            all: {
                bookingsList: sortedBookings,
                emptyState: {
                    text: 'No bookings',
                    image: 'bookings-emptystate.svg'
                }
            },
            ...bookingsGroupedByStatus
        });

        setLoading(false);
    }, [props.bookings]);

    const openBookingPullout = (booking) => {
        const { legacyApiBooking, ...gqlBooking } = booking;

        props.dispatch(openPullout({
            ...legacyApiBooking,
            ...gqlBooking,
            extendedProps: {
                booking: gqlBooking,
                resourceId: parseInt(props.vehicle.id),
                vehicle: props.vehicle
            }
        }))
    }

    const renderTabContent = (tab) => {
        if(!tabs[tab]) return <></>

        const { bookingsList, emptyState } = tabs[tab];

        return (
            !bookingsList.length ? (
                <div className="full_container media_container">
                    <div className="middled_item">
                        <EmptyState image={emptyState.image} text={emptyState.text} />
                    </div>
                </div>
            ) : (
                <table className = "ds-table">
                    <thead>
                        <tr className = "table-header">
                            <th className="align-center"><Trans>Status</Trans></th>
                            <th className="align-left"><Trans>User</Trans></th>
                            <th className="align-center"><Trans>Pool</Trans></th>
                            {/* <th className="align-center"><Trans>User Tier</Trans></th> */}
                            <th className="align-center"><Trans>Booking Date</Trans></th>
                            <th className="align-left"><Trans>Type</Trans></th>
                            <th className="align-center"><Trans># Days</Trans></th>
                            <th className="align-center"><Trans>Damage</Trans></th>
                            <th className="align-center"><Trans>Expenses</Trans></th>
                        </tr>
                    </thead>
                    <tbody>
                        {bookingsList.map((booking, index) =>
                            <BookingRow booking={booking} openBooking={openBookingPullout} alt={index % 2 !== 0} key={booking.BOOK_ID}/>
                        )}
                    </tbody>
                </table>
            )
        )
    }

    if (loading) {
        return <></>
    }

    return (
        <div className="row expanded bkg-white-dark">
            <div className="columns large-12 medium-12 small-12" style={{padding: 0}}>
                <div className="ds-card">
                    <div className="border-bottom" style={{paddingBottom: 16}}>
                        <Tabs value={currentTab} onChange={(e) => setCurrentTab(e.currentTarget.dataset.id)}>
                            {Object.keys(tabs).map(tab => <TabItem label={tab} capitalize />)}
                        </Tabs>
                    </div>
                    <div>
                        {renderTabContent(currentTab)}
                    </div>
                    <div className = "clearfix"></div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    stakeholder: store.stakeholder,
    settings: store.settings
})

export default connect(mapStateToProps)(VehicleBookingsTab)